module.exports = __webpack_public_path__ + "img/IMG_1387.020950e3.jpeg";